import React from 'react'
import { IntlProvider } from 'react-intl'

import useAsync from 'utils/hooks/useAsync'
import { ru } from 'utils/translations'

function AsyncIntlProvider({ children }) {
    const {
        data,
        status,
        error,
        isLoading,
        isIdle,
        isError,
        isSuccess,
        run,
        setData,
    } = useAsync()

    React.useEffect(() => {
        run(Promise.resolve({
            status: 200,
            data: ru
        }))
    }, [run])

    // const value = React.useMemo(() => ({ user, login, logout, register }), [
    //     login,
    //     logout,
    //     register,
    //     user,
    // ])

    if (isLoading || isIdle) {
        return <p>loading</p>
    }

    if (isError) {
        return <p>error</p>
    }

    if (isSuccess) {
        return (
            <IntlProvider messages={data.data} locale="ru" defaultLocale="ru">
                {children}
            </IntlProvider>
        )
    }

    throw new Error(`Unhandled status: ${status}`)
}

export { AsyncIntlProvider }
